import { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_DENSITY = "founder_dashboard_density";
const STORAGE_EXPORT = "founder_dashboard_export_format";

const UiPreferencesContext = createContext(null);

function readStored(key, fallback) {
  try {
    const v = localStorage.getItem(key);
    return v ?? fallback;
  } catch {
    return fallback;
  }
}

export function UiPreferencesProvider({ children }) {
  const [density, setDensityState] = useState(() =>
    readStored(STORAGE_DENSITY, "comfortable")
  );
  const [exportFormat, setExportFormatState] = useState(() =>
    readStored(STORAGE_EXPORT, "pdf")
  );

  const setDensity = useCallback((value) => {
    setDensityState(value);
    try {
      localStorage.setItem(STORAGE_DENSITY, value);
    } catch {
      /* ignore */
    }
  }, []);

  const setExportFormat = useCallback((value) => {
    setExportFormatState(value);
    try {
      localStorage.setItem(STORAGE_EXPORT, value);
    } catch {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({
      density,
      setDensity,
      exportFormat,
      setExportFormat,
    }),
    [density, setDensity, exportFormat, setExportFormat]
  );

  return (
    <UiPreferencesContext.Provider value={value}>{children}</UiPreferencesContext.Provider>
  );
}

export function useUiPreferences() {
  const ctx = useContext(UiPreferencesContext);
  if (!ctx) {
    throw new Error("useUiPreferences must be used within UiPreferencesProvider");
  }
  return ctx;
}
